module.exports = __webpack_public_path__ + "static/media/bannerimg01.8bfb086b.jpg";